import React from 'react'
import Input from 'components/inputs/input'
import Button from 'components/button'
import { COMMON } from 'utils/intl/common.js'
import { useGlobalState } from 'utils/hooks/globalStateProvider'
import { STATUS_SUCCESS, STATUS_ERROR, SUBSCRIPTION_TYPE } from 'utils/constants.js'

function NewsletterForm(props) {
  const {
    className = '',
    title = COMMON.TITLE_REGISTER,
    description = COMMON.NEWSLETTER_PARAGRAPH,
    subscriptionType = SUBSCRIPTION_TYPE.NEWSLETTER,
  } = props

  const isDark = className.includes('newsletter-form--dark')
  const [, dispatch] = useGlobalState()

  const onSubmitForm = (event) => {
    event.preventDefault()
    const value = event.target.email.value

    fetch('https://europe-west3-qovery.cloudfunctions.net/subscribeEmailLandingPage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: value,
        subscription_type: subscriptionType,
      }),
    })
      .then(() => {
        dispatch({
          message: {
            isOpen: true,
            text: COMMON.THANKS_SUBSCRIPTION,
            status: STATUS_SUCCESS,
          },
        })
      })
      .catch(() => {
        dispatch({
          message: {
            isOpen: true,
            text: COMMON.EMAIL_INVALID,
            status: STATUS_ERROR,
          },
        })
      })
  }

  return (
    <div className={`newsletter-form ${className}`}>
      <h3 className={`h2 ft-700 mb-1 ${isDark ? 'c-white' : 'c-text-black-light'}`}>{title}</h3>
      <p className={`${isDark ? 'c-white' : 'c-text-black-light'} mb-0`}>{description}</p>
      <form className="f mt-3 mt-md-5" onSubmit={(e) => onSubmitForm(e)}>
        <Input
          className={`mr-2 ${isDark ? 'input--dark ' : ''}`}
          type="email"
          placeholder={COMMON.YOUR_EMAIL}
          name="email"
          required
        />
        <Button className="btn btn--large" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" fill="none" viewBox="0 0 17 15">
            <path
              fill="#fff"
              d="M16.375 6.656l-14-6A.832.832 0 002 .562c-.281 0-.563.094-.75.313a1.048 1.048 0 00-.156 1.156L4 7.562l-2.906 5.562c-.188.375-.125.844.156 1.125a.998.998 0 00.75.344c.125 0 .25-.031.375-.094l14-6c.375-.156.625-.53.625-.937-.031-.375-.25-.75-.625-.906zM3.062 2.593l9.907 4.219H5.28L3.063 2.593zm2.22 5.719h7.687l-9.906 4.25 2.218-4.25z"
            ></path>
          </svg>
        </Button>
      </form>
    </div>
  )
}

export default NewsletterForm
